import React from 'react';
import classNames from 'classnames';
import { Droppable, Draggable } from 'react-beautiful-dnd';

import { SCORE_OPTIONS_AVERAGE, COLUMNS_OPTIONS, Section_Translated_Data, Fields_With_OPTIONS } from '../../../Context/DynamicFormContext';
import InputText from '../../FormFields/Text';
import Button from '../../Common/Button';
import Checkbox from '../../FormFields/Checkbox';
import InputSelect from '../../FormFields/Select';
import RadioWrapper from '../../FormFields/WrapperRadio';
import { SectionWidgetCollapsable } from '../Widgets/Section/collapsable';
import ModalPreviewForm from '../../LfaScreen/ModalPreviewForm';
import FieldWidgetService from '../../../Services/FieldWidgetService';
import FormContextProvider, { FormContext } from '../../../Context/FormContext';
import WrapperWidgetIcon, {
  COLLAPSE_ICON,
  EXPAND_ICON,
} from '../Widgets/WrapperWidgetIcon';

import './style.scss';
import Utils from '../../../Services/Utils';
import History from '../../../Services/History';
import DynamicForm from '../../../Models/DynamicForm';
import ConfigService from "../../../Services/api/Config";
import _ from 'lodash';

const displayOptions = [
  { value: 0, label: 'Inline', help: 'Field images will be displayed inline.' },
  { value: 1, label: 'At end', help: 'All field images will be gathered together at the end of the file.' },
];

class DFBuilderForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      configuration: null,
      modalPreviewVisible: false,
      sectionCollapsable: {},
      formData: {},
    };
  }

  componentDidMount() {
    History.singleton().register('modalPreview', () => {
     this.onPressedPreview();
    }, () => {
     this.onPressedModalPreviewClose();
    });
    document.addEventListener('keydown', this.onEventUndo);
  }

  componentWillUnmount() {
    History.singleton().unregister('modalPreview');
    document.removeEventListener('keydown', this.onEventUndo);
  }

  onEventUndo = async (e) => {
    let event = window.event || e
    if ((event.which == 90 || event.keyCode == 90) && event.ctrlKey) {
      await this.onPressedUndo();
    }
  };

  onPressedPreview = async () => {
    const { formData } = this.props;
    History.singleton().show('modalPreview');
    const dynamicForm = new DynamicForm(formData);
    const configuration = await dynamicForm.serializeAsync();
    this.setState({
      configuration: configuration,
      modalPreviewVisible: true,
      formData : formData
    });
  };

  onPressedUndo = async () => {
    const { api } = this.props;
    await api.onDFRestoreData();
  };

  onPressedModalPreviewClose = (event) => {
    History.singleton(event).close(event);
    this.setState({ modalPreviewVisible: false });
  };

  showPlaceholder = (provider) => {
    return (provider && provider.placeholder && provider.placeholder.props && !Utils.isNull(provider.placeholder.props.on));
  };

  getEmptyStyles = () => {
    const { dragElementHeight } = this.props;
    return {height:dragElementHeight, marginBottom: -dragElementHeight, borderColor: ConfigService.getColor('secondaryColor', 0.8)};
  };

  collapseAll = () => {
    const { collapseAll } = this.props;
    collapseAll();
  };

  expandAll = () => {
    const { expandAll } = this.props;
    expandAll();
  };

  collapseSection = (sectionId) => {
    const { collapseSection } = this.props;
    collapseSection(sectionId);
  };

  renderSectionField = (field, index, droppableSection, providerSectionField,section) => {
    const { formData, api, triggerTemplates, propertyFields, contactTypes, chargeCodes, pmsPlatforms, unitFields, indexOrigin, indexDestination, isDraggingField, originId, destinationId, availableLanguages } = this.props;
    let myField = angular.copy(field);
    let widthOptions = [];
    // ressign embedded object to myField
    if (field?.embedded?.forEach) {
      field.embedded.forEach((embeddedObj, index) => {
        myField.embedded[index] = embeddedObj;
        });
    }
    
    if(section.columns){
      myField.sectionColumns = section.columns.value;
      for (let i = 1; i <= section.columns.value; i++) {
        widthOptions.push({ value: i.toString(), score: '' });
      }
    }
    myField.displayWidthOptions = widthOptions || [];
    if(availableLanguages && availableLanguages.length > 0){
      myField.updated_in_language = formData.updated_in_language ? formData.updated_in_language : null;
      myField.created_in_language = formData.created_in_language ? formData.created_in_language : null;
    }
    const FieldWidget = FieldWidgetService.getWidget(myField, api, triggerTemplates, propertyFields, contactTypes, chargeCodes, pmsPlatforms, unitFields, index, formData.descriptionAsIcon, formData.showTriggerConditionMet, formData.created_in_language);
    let placeholder = false;
    const destinationIndex = !Utils.isNull(indexDestination) && (indexDestination > indexOrigin) ? indexDestination+1 : indexDestination;

    if (isDraggingField && (destinationId !== 'DraggableWidgetList') && (droppableSection === destinationId)) {
      if (destinationId === originId) {
        placeholder = !Utils.isNull(destinationIndex) ? (index === destinationIndex) : (index === indexOrigin);
      }
      else {
        placeholder = !Utils.isNull(indexDestination) ? (index === indexDestination) : (index === indexOrigin);
      }
    }
    const idSectionField = myField.section ? myField.id.split('#').join('') + '-' + myField.section.split('#').join('') : myField.id.split('#').join('') + '-sectiondividerInitial' ;
    return (
      <Draggable
        key={ myField.id }
        draggableId={ myField.id + '-' + myField.section }
        index={ index }>
        { (providerField, snapshot) => (
          <div>
            { placeholder && this.showPlaceholder(providerSectionField) &&
              <div className='DFBuilderForm_Empty' style={this.getEmptyStyles()}>
              </div>
            }
            <div
              className='DFBuilderForm_Section_Field'
              id={ idSectionField }
              ref={ providerField.innerRef }
              { ...providerField.draggableProps }
              { ...providerField.dragHandleProps }>
              { FieldWidget }
            </div>
          </div>
        ) }
      </Draggable>
    );
  };

  renderSectionFields = (fields, droppableSection, providerSectionField,section) => {
    const {formData, availableLanguages} = this.props
    let newFormData = Object.assign(formData, {});
    return (fields.order || []).map((item, index) => {
      if(availableLanguages && availableLanguages.length > 0 && newFormData.locale && Object.keys(newFormData.locale).length > 0 ){
        Object.keys(newFormData.locale).forEach(key =>{
          fields.items[item][key] = {}
          Section_Translated_Data.forEach(data =>{
            fields.items[item][key][data] = newFormData.locale[key][`${item}_${data}`]
          })
          if(Fields_With_OPTIONS.includes(fields.items[item].component)){
            fields.items[item][key]['options'] = [];
            fields.items[item].options.forEach((option, index) =>{
                let opt = {value : index, label: newFormData.locale[key][`${item}_value-${index}`]}
                fields.items[item][key]['options'].push(opt);
            })
          }
        });
         
      }
      return this.renderSectionField(fields.items[item], index, droppableSection, providerSectionField,section);
    });
  };

  renderSection = (section, index, isOpen) => {
    const {
      api,
      isDraggingSection,
      isDraggingField,
      indexDestination,
      indexOrigin,
      originId,
      destinationId,
      formData,
      availableLanguages
    } = this.props;
    let placeholder = false;
    const destinationIndex = !Utils.isNull(indexDestination) && (indexDestination > indexOrigin) ? indexDestination+1 : indexDestination;
    if ((indexDestination !== 0) && isDraggingSection && (index !== 0) && (destinationId !== 'DraggableWidgetList')) {
      if (destinationId === originId) {
        placeholder = !Utils.isNull(destinationIndex) ? (index === destinationIndex) : (index === indexOrigin);
      }
      else {
        placeholder = !Utils.isNull(indexDestination) ? (index === indexDestination) : (index === indexOrigin);
      }
    }
    const droppableId = index + '-droppable-section';
    const length = (destinationId === originId) ? Object.keys(section.fields.items).length-1 : Object.keys(section.fields.items).length;
    const sameDestiny = (destinationId === originId) && (indexOrigin === indexDestination);
    const newSection = angular.copy(section);

    // ressign embedded object to newSection
    for (const key in section.fields.items) {
      const obj = section.fields.items[key];
      if (obj?.embedded?.forEach) {
          obj.embedded.forEach((embeddedObj, index) => {
              newSection.fields.items[key].embedded[index] = embeddedObj;
          });
      }
    }


    if(availableLanguages && availableLanguages.length > 0){
      newSection.updated_in_language = formData.updated_in_language ? formData.updated_in_language : null;
      newSection.created_in_language = formData.created_in_language ? formData.created_in_language : null;
    }

    return (
      <Draggable
        key={ 'form' + newSection.id }
        draggableId={ 'form' + newSection.id }
        index={ index }
        isDragDisabled={ index === 0 || isOpen }
      >
        { (providerSection, snapshot) => (
          <div>
            { placeholder &&
              <div className='DFBuilderForm_Empty DFBuilderForm_Empty_Section' style={this.getEmptyStyles()}>
              </div>
            }
            <div
              className={classNames('DFBuilderForm_Section', {
                'DFBuilderForm_Section_Dragging': snapshot.isDragging
              })}
              id={ 'form' + newSection.id.split('#').join('') }
              ref={ providerSection.innerRef }
              { ...providerSection.draggableProps }
              { ...providerSection.dragHandleProps }
            >
              <SectionWidgetCollapsable
                section={ newSection }
                api={ api }
                index={ index }
                preventDelete={ index === 0 }
                onCollapse={this.collapseSection}
                isOpen={isOpen}
                languageShown = {newSection.updated_in_language}
              />
              <div className={classNames('DFBuilderForm_Section_Content', {
                'DFBuilderForm_Section_Content_Hidden': !isOpen
              })}>
                <Droppable droppableId={ droppableId } isDropDisabled={ isDraggingSection }>
                  { (providerSectionField, snapshot) => (
                    <div className='Droppable-Area' ref={ providerSectionField.innerRef }>
                      { this.renderSectionFields(newSection.fields, index + '-droppable-section', providerSectionField,newSection, index) }
                      { isDraggingField && (destinationId === droppableId) && (indexDestination === length) && !sameDestiny && this.showPlaceholder(providerSectionField) &&
                        <div className='DFBuilderForm_Empty' style={this.getEmptyStyles()}>
                        </div>
                      }
                      { providerSectionField.placeholder }
                    </div>
                  ) }
                </Droppable>
                <div className='Droppable__Separator' />
              </div>
            </div>
          </div>
        ) }
      </Draggable>
    );
  };

  renderSections = (sections) => {
    const { order, items } = sections;

    const { sectionsCollapsable, formData, availableLanguages } = this.props;
    return order.map((item, index) => {
      const isOpen = !sectionsCollapsable[item];
      if(availableLanguages && availableLanguages.length > 0 && formData.locale && Object.keys(formData.locale).length > 0 ){
        Object.keys(formData.locale).forEach(key =>{
          items[item][key] = {}
            Section_Translated_Data.forEach(data =>{
              items[item][key][data] = formData.locale[key][`${item}_${data}`]
            })
        });
      }
      return this.renderSection(items[item], index, isOpen, formData);
    });
  };

  render() {
    const { formData, api, isDraggingField, sectors, indexDestination, indexOrigin, isDraggingSection, originId, destinationId, clientInstances, undo, availableLanguages } = this.props;
    const { modalPreviewVisible, configuration } = this.state;
    if (!formData) return null;
    const destinationIndex = !Utils.isNull(indexDestination) && (indexDestination !== indexOrigin) &&
    (indexDestination === Object.keys(formData.sections.items).length-1) && (originId === destinationId) ? indexDestination+1 : indexDestination;
    const droppableId = 'droppable';
    const styleTitle = {
      'color': ConfigService.getColor('primaryColor')
    };
    let form_name = formData.name;
    let form_description = formData.description;
    if(availableLanguages && availableLanguages.length > 0){
      form_name = (formData.id && formData.updated_in_language && formData.locale[formData.updated_in_language]) ? formData.locale[formData.updated_in_language].name : (formData.created_in_language && formData.created_in_language.code && formData.locale[formData.created_in_language.code]) ? formData.locale[formData.created_in_language.code].name : formData.name;
      form_description = (formData.id && formData.updated_in_language && formData.locale[formData.updated_in_language]) ? formData.locale[formData.updated_in_language].description : (formData.created_in_language && formData.created_in_language.code && formData.locale[formData.created_in_language.code]) ? formData.locale[formData.created_in_language.code].description : formData.description;
    }
    
    return (
      <FormContextProvider>
        <FormContext.Consumer>
          { context => (
            <div className='DFBuilderForm'>
              <form action='' noValidate>
                <div className='DFBuilderForm_Common Table'>
                  { formData.isStaff && formData.clientInstance &&
                    <InputSelect label='Client Instance:' value={ formData.clientInstance } multiple={ true }
                                 onChange={ v => api.onDFBasicValueChange('clientInstance', v) } disabled={ true }
                                 options={ clientInstances.map((clientInstance) => { return {value: clientInstance.id, label: clientInstance.name} }) }/>
                  }
                  <InputText label='Form name' value={ form_name } required={ true }
                             onChange={ v => api.onDFBasicValueChange('name', v) } error={ formData.errors['name'] }
                             onError={ (error) => api.onDFErrorChange('name', error) } onBlur= {() => api.FormDataChange('name')} onFocus={()=>{api.handleTranslationsOnFocus('name',form_name)}}/>
                  <InputText label='Description' value={ form_description } required={ true }
                             onChange={ v => api.onDFBasicValueChange('description', v) }
                             error={ formData.errors['description'] }
                             onError={ (error) => api.onDFErrorChange('description', error) }  onBlur= {() => api.FormDataChange('description')} onFocus={()=>{api.handleTranslationsOnFocus('description',form_description)}}/>
                  <InputSelect label='Score type' options={ SCORE_OPTIONS_AVERAGE } value={ formData.scoreType }
                               onChange={ v => api.onDFBasicValueChange('scoreType', v) }/>
                  <InputSelect label='Number of columns on screen' options={ COLUMNS_OPTIONS } value={ formData.columns }
                               onChange={ v => api.onDFBasicValueChange('columns', v.value) }/>
                  <RadioWrapper label='Images Position' options={ displayOptions } name='imagesLayout'
                                value={ formData.imagesLayout } onChange={ api.onDFBasicValueChange }/>
                  { formData.isStaff &&
                    <InputSelect label='Limit to sectors:' value={ formData.sectors } multiple={ true }
                                 onChange={ v => api.onDFBasicValueChange('sectors', v) }
                                 options={ sectors.map((sector) => { return {value: sector.id, label: sector.name} }) }/>
                  }
                  <Checkbox onChange={ (v) => api.onDFBasicValueChange('required', v) }
                            label='Required'
                            checked={ formData.required }
                            className='InputCheckbox_Block'
                  />
                  <Checkbox onChange={ (v) => api.onDFBasicValueChange('showUnselectedCheckbox', v) }
                            label='Show unselected checkbox options'
                            checked={ formData.showUnselectedCheckbox }
                            className='InputCheckbox_Block'
                  />
                  <Checkbox onChange={ (v) => api.onDFBasicValueChange('workflowStatistics', v) }
                            label='Show Unit workflow statistics'
                            checked={ formData.workflowStatistics }
                            className='InputCheckbox_Block'
                  />
                  <Checkbox onChange={ (v) => api.onDFBasicValueChange('descriptionAsIcon', v) }
                            label='Show descriptions as icon'
                            checked={ formData.descriptionAsIcon }
                            className='InputCheckbox_Block'
                  />
                  <Checkbox onChange={ (v) => api.onDFBasicValueChange('showTriggerConditionMet', v) }
                            label='Show trigger condition met'
                            checked={ formData.showTriggerConditionMet }
                            className='InputCheckbox_Block'
                  />
                  <div className="DFBuilderForm_Common_Footer">
                    <Button className='Button_Small Button_Black Right'
                            onClick={ this.onPressedPreview }>
                      Test Form
                    </Button>
                    <Button className={ classNames('Button_Small Left', { Button_Cancel: !undo })}
                      onClick={ this.onPressedUndo }>
                      Undo
                    </Button>
                  </div>
                </div>
                <div className='DFBuilderForm_Dynamic'
                     style={ {'backgroundColor': ConfigService.getColor('tertiaryColor', 0.15)} }>
                  <div className='DFBuilderForm_Dynamic_Title Center' style={ styleTitle }>- Property name will go here -</div>
                  <div className="DFBuilderForm_Dynamic_Actions Table">
                    <Button
                      className='Button Button_Small_Extra Button_Collapsable Right'
                      onClick={this.collapseAll}
                      btnText={'Collapse all'}
                    >
                      <WrapperWidgetIcon display type={COLLAPSE_ICON} />
                    </Button>
                    <Button
                      className='Button Button_Small_Extra Button_Collapsable Right'
                      onClick={this.expandAll}
                      btnText={'Expand all'}
                    >
                      <WrapperWidgetIcon display type={EXPAND_ICON} />
                    </Button>
                  </div>
                  <Droppable droppableId={ droppableId } isDropDisabled={ isDraggingField }>
                    { (providerForm, snapshot) => (
                      <div ref={ providerForm.innerRef }>
                        { this.renderSections(formData.sections) }
                        { isDraggingSection && (destinationIndex === Object.keys(formData.sections.items).length) && this.showPlaceholder(providerForm) &&
                          <div className='DFBuilderForm_Empty DFBuilderForm_Empty_Section' style={this.getEmptyStyles()}>
                          </div>
                        }
                        { providerForm.placeholder }
                      </div>
                    ) }
                  </Droppable>
                </div>
                <div className='DFBuilderForm_Footer Table'>
                  <Button className='Button_Small Left'
                          onClick={ () => context.submit(() =>api.submit(true), formData.errors) }>Save changes
                  </Button>
                  <Button className='Button_Small Right'
                          onClick={ () => context.submit(api.submit, formData.errors) }>Save changes and exit
                  </Button>
                </div>
              </form>
              { modalPreviewVisible && (
                <ModalPreviewForm
                  configuration={ configuration }
                  onClose={ this.onPressedModalPreviewClose }
                  availableLanguages={availableLanguages}
                />
              ) }
            </div>
          ) }
        </FormContext.Consumer>
      </FormContextProvider>
    );
  }
}

export default DFBuilderForm;